var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 1.66669V18.3334M18.3333 10L1.66666 10M15.8333 12.9167H12.5M15.8333 15.4167H12.5M4.99999 18.3334H15C16.8409 18.3334 18.3333 16.841 18.3333 15V5.00002C18.3333 3.15907 16.8409 1.66669 15 1.66669H4.99999C3.15904 1.66669 1.66666 3.15907 1.66666 5.00002V15C1.66666 16.841 3.15904 18.3334 4.99999 18.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavTopics);
export default __webpack_public_path__ + "static/media/sidenav-topics.900a44b76e977b666d87513f5955c7e5.svg";
export { ForwardRef as ReactComponent };